<template>
  <v-dialog v-on="$listeners" v-bind="$attrs">
    <v-card>
      <v-card-title id="c-title">
        <slot name="header" />
      </v-card-title>

      <v-divider />

      <v-card-text id="c-body">
        <slot name="body" />
      </v-card-text>

      <v-divider />

      <v-card-actions id="c-footer">
        <slot name="footer" />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>

export default {

}

</script>
<style scoped>
#c-title {
  display:flex;
  flex-direction:column;
  color: #009280;
  overflow-y: auto;
  min-height: 5vh;
}
#c-body {
  padding: 15px 20px;
  overflow-y: auto;
  min-height: 50vh;
  max-height: 75vh;
}
#c-footer {
  min-height: 5vh;
}
#c-body::-webkit-scrollbar {
  width: 0.88vh;
}
#c-body::-webkit-scrollbar-thumb {
  border: none;
  background: linear-gradient(0, #9926FF 0%, #6e6fe0 20%, #47b4c4 70%, #33D6B5 99%);
}
</style>
<style>
@media (orientation: landscape) {
  .v-dialog {
    min-width: 33%;
    max-width: 50%;
    max-height: 90% !important;
    margin: auto !important;
  }
}
@media (orientation: portrait) {
  .v-dialog {
    max-width: 95%;
    max-height: 95% !important;
    margin: auto !important;
  }
}
</style>
